import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AccVentureFuncData } from '@interfaces';
import { DomainDataService } from '../../../../../../../services';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';
import { AccCohortPageService, } from '../../../acc-cohort.page.service';
import { getSetup } from './grid/get-setup';

export interface AccVenture extends AccVentureFuncData {
	teamName: string | undefined,
	entrepreneurNames: string | undefined,
	industry: string | undefined,
	dropoutReason: string | undefined,
}


@Component({
	selector: 'acc-ventures-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-ventures-view.part.html',
})
export class AccVenturesViewPart {

	private readonly util = inject(UtilityService);
	private readonly dialogService = inject(DialogService);
	private readonly domain = inject(DomainDataService);
	private readonly pageService = inject(AccCohortPageService);
	private readonly areaService = inject(AcceleratorAreaService);

	public setup = getSetup(this.util, this.dialogService, this.areaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public accVentures = computed<AccVenture[]>(() => {
		const data = this.areaService.data();
		const accTeamMap = this.areaService.accTeamMap();
		if (!data) return [];

		const entrepreneursMap = data.entrepreneurs.reduce((map, ent) => {
			const key = ent.accVentureId;
			if (!map[key]) {
				map[key] = [];
			}
			map[key].push(ent.fullName ?? `${ent.firstName} ${ent.lastName}`);
			return map;
		}, {} as Record<number, string[]>);

		return data.ventures.map(v => ({
			...v,
			teamName: accTeamMap[v.accTeamId]?.name ?? undefined,
			entrepreneurNames: entrepreneursMap[v.accVentureId]?.join(', '),
			industry: this.domain.data().industriesMap[v.industryId]?.name,
			dropoutReason: v.dropout?.dropoutReasonId ? this.domain.data().dropoutReasonsMap[v.dropout.dropoutReasonId]?.name : undefined,
		}));
	});
}